import { ReactNode } from 'react';
import styles from './Modal.module.scss';

interface ModalBodyProps {
  children: ReactNode;
}

const ModalBody = ({ children }: ModalBodyProps) => {
  return <div className={styles.modal__body}>{children}</div>;
};

export default ModalBody;
